module.exports = __webpack_public_path__ + "static/media/JS_littlebuddy.7c28b547.png";


//////////////////
// WEBPACK FOOTER
// ./src/images_hd/JS/JS_littlebuddy.png
// module id = 716
// module chunks = 0